window.otpvalue = "";
window.tokenid = "";
window.otpExpired = "";
window.MobileNumber = "";
window.register_subtext = "";
window.ITI = null;
window.originalTextBtnOTP = null;
$(document).ready(function () {
  window.originalTextBtnOTP = $("#btn-get-otp").text();
  $("#form-validate-otp").hide();
  $(".detail-field").hide();

  $(document).on("submit", "#form-get-otp", function (e) {
    e.preventDefault();
    
    // Check if we're on the correct URL
    if (window.location.href !== "https://shop.friso.com.hk/account/register") {
      alert("此表單只能在註冊頁面使用");
      return false;
    }
    
    // Execute reCAPTCHA
    if (typeof grecaptcha !== 'undefined' && window.recaptchaWidgetId !== undefined) {
      grecaptcha.execute(window.recaptchaWidgetId);
    } else {
      alert("reCAPTCHA 尚未載入，請稍後再試");
    }
    
    return false;
  });

  $(document).on("submit", "#form-validate-otp", function (e) {
    e.preventDefault();
    let listFields = $(this).serializeArray();
    validateOTP(listFields);
    return false;
  });

  $(document).on("submit", "#form-register-detail", function (e) {
    e.preventDefault();
    if(!checkRequiredFields(false, "register")) {
      alert('請填寫所有必須填寫資料.')
      return;
    }
    if(!checkNameValidate()) {
      alert('請填寫正確的英文姓氏及英文姓名.')
      return;
    }
    let listFields = $(this).serializeArray();
    registerCustomer(listFields);
    return false;
  });

  $(document).on("submit", "#form-edit-profile", function (e) {
    e.preventDefault();
    if(!checkRequiredFields(true, "profile")) {
      alert('請填寫所有必須填寫資料.')
      return;
    }
    if(!checkNameValidate()) {
      alert('請填寫正確的英文姓氏及英文姓名.')
      return;
    }
    let listFields = $(this).serializeArray();
    editProfile(listFields);
    return false;
  });

  $(document).on("submit", "#form-edit-step3", function (e) {
    e.preventDefault();
    if(!checkRequiredFields(true, "step3")) {
      alert('請填寫所有必須填寫資料.')
      return;
    }
    if(!checkNameValidate()) {
      alert('請填寫正確的英文姓氏及英文姓名.')
      return;
    }
    let listFields = $(this).serializeArray();
    editProfileExisting(listFields);
    return false;
  });

  $(document).on("submit", "#form-new-pregnant", function (e) {
    e.preventDefault();
    if(!checkRequiredFields(true, "step4")) {
      alert('請填寫所有必須填寫資料.')
      return;
    }
    let listFields = $(this).serializeArray();
    newPregnant(listFields);
    return false;
  });

  $(document).on("submit", "#form-new-child", function (e) {
    e.preventDefault();
    if(!checkRequiredFields(true, "step5")) {
      alert('請填寫所有必須填寫資料.')
      return;
    }
    let listFields = $(this).serializeArray();
    newChild(listFields);
    return false;
  });

  $(document).on("click", "#edit-phone", function (e) {
    e.preventDefault();
    $("#form-get-otp").show();
    countdownOTP(0);
    $("#form-validate-otp").hide();
    $(".detail-field").hide();
    return false;
  });

  $(document).on("click", "#edit-email", function (e) {
    e.preventDefault();
    hideSocial(0);
    $("#register_subtext").text(window.register_subtext);
    return false;
  });

  $('#condition').on('change', function() {
    validateDob();
  });
  $('.dob-wrapper select').on('change', function() {
    validateDob();
  });
  $('.dob-wrapper-1 select').on('change', function() {
    validateDob();
  });
  $('.dob-wrapper-2 select').on('change', function() {
    validateDob();
  });
});

function checkNameValidate(){
  let inValids = [];
  const regex = /\`|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\+|\=|\[|\{|\]|\}|\||\\|\'|\<|\,|\.|\>|\?|\/|\""|\;|\:|[0-9]/g;
  $(".input-name").each(function(i, el){
    if(regex.test(el.value)){
      inValids.push(false);
      $(el).addClass('error-field');
    }
  });

  if(inValids.length) {
    return false;
  }
  return true;
}

function getConditionNum() {
  const condition = $('#condition').val();
  if(condition == '') {
    $('.condition-wrapper').addClass('error-field');
    $('.form-condition-1').find('.dob-wrapper').addClass('error-field');
    return 1;
  }
  $('.condition-wrapper').removeClass('error-field');

  let num = 1;
  if(condition == 'BB已出生') {
    num = 2;
  }
  if(condition == '懷孕中及已有出生BB') {
    num = 3;
  }

  return num;
}

function validateDob() {
  const conditionNum = getConditionNum();
  if(conditionNum == 3) {
    const dobDay1 = $(`#bday-form-1-condition-${conditionNum}-1`);
    const dobMonth1 = $(`#bmonth-form-1-condition-${conditionNum}-1`);
    const dobYear1 = $(`#byear-form-1-condition-${conditionNum}-1`);

    const dobDay2 = $(`#bday-form-1-condition-${conditionNum}-2`);
    const dobMonth2 = $(`#bmonth-form-1-condition-${conditionNum}-2`);
    const dobYear2 = $(`#byear-form-1-condition-${conditionNum}-2`);

    let dob1Valid = true;
    let dob2Valid = true;
    if(dobDay1.val() == '' || dobMonth1.val() == '' || dobYear1.val() == '') {
      dob1Valid = false;
      $(`.form-condition-${conditionNum}`).find('.dob-wrapper-1').addClass('error-field');
    } else {
      $(`.form-condition-${conditionNum}`).find('.dob-wrapper-1').removeClass('error-field');
    }

    if(dobDay2.val() == '' || dobMonth2.val() == '' || dobYear2.val() == '') {
      dob2Valid = false;
      $(`.form-condition-${conditionNum}`).find('.dob-wrapper-2').addClass('error-field');
    } else {
      $(`.form-condition-${conditionNum}`).find('.dob-wrapper-2').removeClass('error-field');
    }

    if(!dob1Valid || !dob2Valid) {
      return;
    }
  } else {
    const dobDay = $(`#bday-form-1-condition-${conditionNum}`);
    const dobMonth = $(`#bmonth-form-1-condition-${conditionNum}`);
    const dobYear = $(`#byear-form-1-condition-${conditionNum}`);
    if(dobDay.val() == '' || dobMonth.val() == '' || dobYear.val() == '') {
      $(`.form-condition-${conditionNum}`).find('.dob-wrapper').addClass('error-field');
      return false;
    }

    $(`.form-condition-${conditionNum}`).find('.dob-wrapper').removeClass('error-field');
  }

  return true;
}

function checkRequiredFields(isEdit, pg) {
  const isValidArr = [];

  if(isEdit == false && pg == "register"){
    const num = getConditionNum();
    const dob = validateDob();
    if(!dob) {
      isValidArr.push(false);
    }

    const cb_optins = $(`.form-condition-${num} .cb_required`);
    $(cb_optins).each(function (i, e){
      if($(e).prop('checked') == false){
        $(e).closest(".cb-container").addClass('error-field');
        isValidArr.push(false);
      }
    });
  }

  if(isEdit == true && pg == "step3"){
    const cb_optins = $(`#form-edit-step3 .cb_required`);
    $(cb_optins).each(function (i, e){
      if($(e).prop('checked') == false){
        $(e).closest(".cb-container").addClass('error-field');
        isValidArr.push(false);
      }
    });
  }

  if(isEdit == true && pg == "step4"){
    const dobDay4 = $('#bday');
    const dobMonth4 = $('#bmonth');
    const dobYear4 = $('#byear');
    if(dobDay4.val() == '' || dobMonth4.val() == '' || dobYear4.val() == '') {
      $('#step4-dob').closest('.dob-wrapper').addClass('error-field');
      isValidArr.push(false);
    }else{
      $('#step4-dob').closest('.dob-wrapper').removeClass('error-field');
    }

    const radios = $(`.organic-products-radio input:radio`);
    let checkRadios = false;
    $(radios).each(function (i, e){
      if($(e).prop('checked')){
        checkRadios = true;
      }
    });
    if(checkRadios == false) {
      $('.organic-products-radio').closest(".t-flex").addClass('error-field');
      isValidArr.push(false);
    }

    const supplement = $("#step4-supplement-products");
    if(supplement.val() == '') {
      $(supplement).closest(".global-select-div").addClass('error-field');
      isValidArr.push(false);
    }
  }

  if(isEdit == true && pg == "step5"){
    const dobDay5 = $('#bday');
    const dobMonth5 = $('#bmonth');
    const dobYear5 = $('#byear');
    if(dobDay5.val() == '' || dobMonth5.val() == '' || dobYear5.val() == '') {
      $('#step5-child-dob').closest('.dob-wrapper').addClass('error-field');
      isValidArr.push(false);
    }else{
      $('#step5-child-dob').closest('.dob-wrapper').removeClass('error-field');
    }

    const radios = $(`.organic-products-radio input:radio`);
    let checkRadios = false;
    $(radios).each(function (i, e){
      if($(e).prop('checked')){
        checkRadios = true;
      }
    });
    if(checkRadios == false) {
      $('.organic-products-radio').closest(".t-flex").addClass('error-field');
      isValidArr.push(false);
    }
  }

  if(isEdit == true && pg == "profile"){
    const num = getConditionNum();
    const cb_optins = $(`.form-condition-${num} .cb_required`);
    $(cb_optins).each(function (i, e){
      if($(e).prop('checked') == false){
        $(e).closest(".cb-container").addClass('error-field');
        isValidArr.push(false);
      }
    });

    const orgnanicProduct = $(`.condition-${num}-organic-products input:radio`);
    let checkOP = false;
    $(orgnanicProduct).each(function (i, e){
      if($(e).prop('checked')){
        checkOP = true;
      }
    });
    if(checkOP == false) {
      $(`.condition-${num}-organic-products`).closest(".t-flex").addClass('error-field');
      isValidArr.push(false);
    }

    const address1 = $(`#condition${num}-form2-address1`);
    if($(address1).val() == ''){
      address1.addClass('error-field');
      isValidArr.push(false);
    }

    const address2 = $(`#condition${num}-form2-address2`);
    if($(address2).val() == ''){
      address2.addClass('error-field');
      isValidArr.push(false);
    }

    const area1 = $(`#condition${num}-form2-area`);
    if($(area1).val() == ''){
      area1.closest(".global-select-div").addClass('error-field');
      isValidArr.push(false);
    }

    if(num == 1){
      const bblastname = $(`#condition${num}-form2-baby-last-name`);
      if($(bblastname).val() == ''){
        bblastname.addClass('error-field');
        isValidArr.push(false);
      }

      const bbfirstname = $(`#condition${num}-form2-baby-first-name`);
      if($(bbfirstname).val() == ''){
        bbfirstname.addClass('error-field');
        isValidArr.push(false);
      }
    }

    if(num == 2){
      const childlastname = $(`#condition${num}-form2-child-last-name`);
      if($(childlastname).val() == ''){
        childlastname.addClass('error-field');
        isValidArr.push(false);
      }

      const childfirstname = $(`#condition${num}-form2-child-first-name`);
      if($(childfirstname).val() == ''){
        childfirstname.addClass('error-field');
        isValidArr.push(false);
      }
    }

    if(num == 3){
      const bblastname = $(`#condition${num}-form2-baby-last-name`);
      if($(bblastname).val() == ''){
        bblastname.addClass('error-field');
        isValidArr.push(false);
      }

      const bbfirstname = $(`#condition${num}-form2-baby-first-name`);
      if($(bbfirstname).val() == ''){
        bbfirstname.addClass('error-field');
        isValidArr.push(false);
      }

      const childlastname = $(`#condition${num}-form2-child-last-name`);
      if($(childlastname).val() == ''){
        childlastname.addClass('error-field');
        isValidArr.push(false);
      }

      const childfirstname = $(`#condition${num}-form2-child-first-name`);
      if($(childfirstname).val() == ''){
        childfirstname.addClass('error-field');
        isValidArr.push(false);
      }
    }
  }

  if(isValidArr.length) {
    return false;
  }
  return true;
}

function fbLogin(isLogin) {
  if(window.fb.validLogin == true){
    fbHandler(isLogin, window.fb.response);
  }else{
    FB.login(function (response) {
      if (response.authResponse) {
        FB.api("/me", "get", { fields: "id, name, email" }, function (meResponse) {
          if(meResponse.email !== undefined){
            window.fb.validLogin = true
            window.fb.response = meResponse
            fbHandler(isLogin, meResponse);
          }else{
            alert("請在接下來的幾分鐘內重試.");
            FB.logout();
          }
        });
      }else{
        console.log('User cancelled login or did not fully authorize.');
      }
    },{scope: 'public_profile,email'});
  }
}

function fbHandler(isLogin, thisResponse){
  if( isLogin === 1 ){
    console.log(thisResponse);
    socialLogin(thisResponse.id, thisResponse.email);
  }else{
    let first = thisResponse.name;
    let last = "";
    if(thisResponse.name.includes(" ")){
      let name = thisResponse.name.split(" ");
      first = name[0];
      $.each(name, function( i, v ) {
        if(i == 1){
          last = v
        }
        if(i > 1){
          last = last +" "+v;
        }
      });
    }
    formBySocial(thisResponse.id, thisResponse.email, first, last)
  }
}

function parseJwt(token) {
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
}

function onSignIn(googleUser) {
  let responsePayload = parseJwt(googleUser.credential);
  socialLogin(responsePayload.sub, responsePayload.email);
}

function onSignInForRegister(googleUser) {
  let responsePayload = parseJwt(googleUser.credential);
  formBySocial(responsePayload.sub, responsePayload.email, responsePayload.given_name, responsePayload.family_name);
  //console.log(responsePayload);
}

function getOTP(listFields) {
  $("#global-loading").show();
  let phone = $("#inputPhoneNumber").val();
  phone = window.ITI.getSelectedCountryData().dialCode + "" + phone;
  listFields[0].value = phone;
  window.MobileNumber = phone;
  listFields.push({ name: "action", value: "get-otp" });
  $.ajax({
    type: "POST",
    url: "/apps/integration",
    data: listFields,
    dataType: "json",
    success: function (data) {
      if (data.api === true) {
        window.otpvalue = data.otp;
        window.tokenid = data.tokenid;
        window.otpExpired = data.expired;
        //alert("OTP 代碼: "+data.otp);
        countdownOTP(1);
        $("#form-validate-otp").show();
        console.log(data);
      } else {
        alert(data.msg);
        //console.log(data);
      }
    },
  }).always(function () {
    $("#global-loading").hide();
  });
}

// New function to handle OTP request with reCAPTCHA
function getOTPWithRecaptcha(listFields, recaptchaToken) {
  $("#global-loading").show();
  let phone = $("#inputPhoneNumber").val();
  phone = window.ITI.getSelectedCountryData().dialCode + "" + phone;
  window.MobileNumber = phone;
  
  // Prepare new payload format
  const payload = {
    action: "get-otp-v2",
    phone: phone,
    recaptcha: recaptchaToken
  };
  
  $.ajax({
    type: "POST",
    url: "/apps/integration",
    data: payload,
    dataType: "json",
    beforeSend: function(xhr) {
      // Add required headers
      xhr.setRequestHeader('Edge-Bot-Score', getBotScore());
      xhr.setRequestHeader('Shopify-Bot-Human-Score', getHumanScore());
    },
    success: function (data) {
      if (data.api === true) {
        window.otpvalue = data.otp;
        window.tokenid = data.tokenid;
        window.otpExpired = data.expired;
        countdownOTP(1);
        $("#form-validate-otp").show();
        console.log(data);
      } else {
        alert(data.msg);
      }
      // Reset reCAPTCHA for next use
      if (typeof grecaptcha !== 'undefined' && window.recaptchaWidgetId !== undefined) {
        grecaptcha.reset(window.recaptchaWidgetId);
      }
    },
    error: function(xhr, status, error) {
      alert("請求失敗，請稍後再試");
      console.error("OTP request failed:", error);
      // Reset reCAPTCHA on error
      if (typeof grecaptcha !== 'undefined' && window.recaptchaWidgetId !== undefined) {
        grecaptcha.reset(window.recaptchaWidgetId);
      }
    }
  }).always(function () {
    $("#global-loading").hide();
  });
}

// Function to get bot score from Shopify
function getBotScore() {
  // Check if Shopify exposes bot score
  if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.meta) {
    return window.Shopify.analytics.meta.botScore || "0.9";
  }
  
  // Check for meta tags or data attributes
  const botScoreMeta = document.querySelector('meta[name="shopify-bot-score"]');
  if (botScoreMeta) {
    return botScoreMeta.content;
  }
  
  // Fallback placeholder
  return "0.9";
}

// Function to get human score from Shopify
function getHumanScore() {
  // Check if Shopify exposes human score
  if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.meta) {
    return window.Shopify.analytics.meta.humanScore || "0.1";
  }
  
  // Check for meta tags or data attributes
  const humanScoreMeta = document.querySelector('meta[name="shopify-human-score"]');
  if (humanScoreMeta) {
    return humanScoreMeta.content;
  }
  
  // Fallback placeholder
  return "0.1";
}

function validateOTP(listFields) {
  let otp = $("#otp").val();
  if (otp == window.otpvalue) {
    $("#global-loading").show();
    listFields.push({ name: "action", value: "validate-otp" });
    listFields.push({ name: "tokenid", value: window.tokenid });
    listFields.push({ name: "expired", value: window.otpExpired });
    $.ajax({
      type: "POST",
      url: "/apps/integration",
      data: listFields,
      dataType: "json",
      success: function (data) {
        if (data.api === true) {
          //console.log(data);
          countdownOTP(0);
          $("#phone-text").text(window.MobileNumber);
          $("#form-get-otp").hide();
          $("#otp").val("");
          $("#form-validate-otp").hide();
          $(".detail-field").show();
        } else {
          alert(data.msg);
          //console.log(data);
          if(data.api == 2){
            $("#form-get-otp").show();
            countdownOTP(0);
            $("#form-validate-otp").hide();
          }
        }
      },
    }).always(function () {
      $("#global-loading").hide();
    });
  } else {
    alert("驗證碼錯誤.");
  }
}

function countdownOTP(i){
  if( i == 1){
    let delay = 30
    $("#btn-get-otp").text(delay+"s");
    $("#btn-get-otp").prop("disabled", true).addClass("this-disabled");

    otpInterval = setInterval(function () {
      delay -= 1;
      $("#btn-get-otp").text(delay+"s");
      if(delay == 0 ){
        clearInterval(otpInterval);
        $("#btn-get-otp").prop("disabled", false).removeClass("this-disabled");
        $("#btn-get-otp").text(window.originalTextBtnOTP);
      }
    }, 1000);
  }else{
    clearInterval(otpInterval);
    $("#btn-get-otp").text(window.originalTextBtnOTP);
    $("#btn-get-otp").prop("disabled", false).removeClass("this-disabled");
  }
}

function registerCustomer(listFields) {
  $("#global-loading").show();
  listFields.push({ name: "action", value: "register-customer" });
  listFields.push({ name: "MobileNumber", value: window.MobileNumber });
  $.ajax({
    type: "POST",
    url: "/apps/integration",
    data: listFields,
    dataType: "json",
    success: function (data) {
      if (data.api === true) {
        autoLogin(data.customer.email, data.customer.pass);
      } else {
        alert(data.msg);
        $("#global-loading").hide();
      }
    },
  });
}

function autoLogin(email, pass) {
  $.ajax({
    type: "POST",
    url: "/account/login",
    data: {
      form_type: "customer_login",
      "customer[email]": email,
      "customer[password]": pass,
    },
    dataType: "json"
  }).always(function () {
    location.href = "/";
  });
}

function editProfile(listFields) {
  $("#global-loading").show();
  listFields.push({ name: "action", value: "edit-profile" });
  $.ajax({
    type: "POST",
    url: "/apps/integration",
    data: listFields,
    dataType: "json",
    success: function (data) {
      if (data.api === true) {
        location.href = "/account?success=1";
      } else {
        alert(data.msg);
        $("#global-loading").hide();
      }
    },
  });
}

function editProfileExisting(listFields) {
  $("#global-loading").show();
  listFields.push({ name: "action", value: "edit-profile-existing" });
  $.ajax({
    type: "POST",
    url: "/apps/integration",
    data: listFields,
    dataType: "json",
    success: function (data) {
      if (data.api === true) {
        location.href = "/account?success=1";
      } else {
        alert(data.msg);
        $("#global-loading").hide();
      }
    },
  });
}

function newPregnant(listFields) {
  $("#global-loading").show();
  listFields.push({ name: "action", value: "new-pregnant" });
  $.ajax({
    type: "POST",
    url: "/apps/integration",
    data: listFields,
    dataType: "json",
    success: function (data) {
      if (data.api === true) {
        location.href = "/account?success=1";
      } else {
        alert(data.msg);
        $("#global-loading").hide();
      }
    },
  });
}

function newChild(listFields) {
  $("#global-loading").show();
  listFields.push({ name: "action", value: "new-child" });
  $.ajax({
    type: "POST",
    url: "/apps/integration",
    data: listFields,
    dataType: "json",
    success: function (data) {
      if (data.api === true) {
        location.href = "/account?success=1";
      } else {
        alert(data.msg);
        $("#global-loading").hide();
      }
    },
  });
}

function socialLogin(id,email) {
  $("#global-loading").show();
  $.ajax({
    type: "POST",
    url: "/apps/integration",
    data: {action: "login-social", social_id: id, email: email},
    dataType: "json",
    success: function (data) {
      if (data.api === true) {
        location.href = data.url;
      } else {
        //console.log(data);
        alert('"此電子郵件地址尚未註冊易訂帳戶"\n請註冊一個新帳戶');
        $("#global-loading").hide();
      }
    },
  });
}

function formBySocial(id,email,first,last){
  let pass = makePass(16);
  $("#social_id").val(id).trigger("change");
  $("#first_name").val(first).trigger("change");
  $("#last_name").val(last).trigger("change");
  $("#email").val(email).trigger("change");
  $("#pass").val(pass).trigger("change");
  $("#email-text").text(email);
  hideSocial(1);

  window.register_subtext = $("#register_subtext").text();
  $("#register_subtext").text("請填寫資料");
}

function hideSocial(i){
  if(i == 1){
    $(".social_login_part").hide();
    $(".password_input").hide();
    $(".email_input").hide();
    $(".email_input_text").show();
  }else{
    $("#social_id").val("").trigger("change");
    $("#email").val("").trigger("change");
    $("#pass").val("").trigger("change");
    $("#email-text").text("XXXXXXXXXX");

    $(".social_login_part").show();
    $(".password_input").show();
    $(".email_input").show();
    $(".email_input_text").hide();
  }
}

function makePass(length) {
  let result = "";
  let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

function loadInformation(pg){
  $("#global-loading").show();
  $.ajax({
    type: "POST",
    url: "/apps/integration",
    data: {action: "load-information", customer: JSON.stringify(window.customer), pg: pg,},
    dataType: "json",
    success: function (data) {
      if (data.api == true) {
        let params = data.informations;
        let parent = data.parent;
        if(pg == "step3"){
          $("#step3-english-firstname").val(parent.momFName);
          $("#step3-english-lastname").val(parent.momLName);
          $("#step3-english-firstname-text").text(parent.momFName);
          $("#step3-english-lastname-text").text(parent.momLName);
          $("#step3-room").val(parent.UnitOrRoom).trigger("change");
          $("#step3-address1").val(parent.address1).trigger("change");
          $("#step3-address2").val(parent.address2).trigger("change");
          $("#step3-tnc").attr("checked",true).trigger("change");
          $("#step3-personal-info-collection").attr("checked",true).trigger("change");

          if(parent.Partition != ""){
            $("#step3-area").val(parent.Partition).trigger("change");
            $("#step3-area").prev().find(".option[data-value='"+parent.Partition+"']").trigger("click");
          }
          if(parent.optin == true){
            $("#step3-promotion").attr("checked",true).trigger("change");
          }
        }else{
          $("#first_name").val(parent.momFName);
          $("#last_name").val(parent.momLName);
          $("#profile-first_name-text").text(parent.momFName);
          $("#profile-last_name-text").text(parent.momLName);
        }

        let opt_text = "懷孕中";
        if(data.opt == 1){
          if(pg == "step3"){
            $("#profile-dob-text").text(params.expectedDOD).closest(".parent-profile-dob-text").show();
            $("#profile-dob-value").val(params.expectedDOD).trigger("change");
            $("#profile-unborn-firstname").val(params.UnBornBabyFName).trigger("change");
            $("#profile-unborn-lastname").val(params.UnBornBabyLName).trigger("change");
          }else{
            $("#profile-condition1-form1-dob-text").text(params.expectedDOD);
            $("#condition1-form1-dob").val(params.expectedDOD).trigger("change");
            $("#condition1-form1-tnc").attr("checked",true).trigger("change");
            $("#condition1-form1-personal-info-collection").attr("checked",true).trigger("change");
            if(parent.optin == true){
              $("#condition1-form1-promotion").attr("checked",true).trigger("change");
            }
          }
        }
        if(data.opt == 2){
          opt_text = "BB已出生";
          if(pg == "step3"){
            $("#profile-child-dob-text").text(params.bornBabyDOB).closest(".parent-profile-child-dob-text").show();
            $("#profile-child-dob-value").val(params.bornBabyDOB).trigger("change");
            $("#profile-child-firstname").val(params.bornBabyFName).trigger("change");
            $("#profile-child-lastname").val(params.bornBabyLName).trigger("change");
          }else{
            $("#profile-condition2-form1-dob-text").text(params.bornBabyDOB);
            $("#condition2-form1-dob").val(params.bornBabyDOB).trigger("change");
            $("#condition2-form1-tnc").attr("checked",true).trigger("change");
            $("#condition2-form1-personal-info-collection").attr("checked",true).trigger("change");
            if(parent.optin == true){
              $("#condition2-form1-promotion").attr("checked",true).trigger("change");
            }
          }
        }
        if(data.opt == 3){
          opt_text = "懷孕中及已有出生BB";
          if(pg == "step3"){
            $("#profile-dob-text").text(params.expectedDOD).closest(".parent-profile-dob-text").show();
            $("#profile-dob-value").val(params.expectedDOD).trigger("change");
            $("#profile-unborn-firstname").val(params.UnBornBabyFName).trigger("change");
            $("#profile-unborn-lastname").val(params.UnBornBabyLName).trigger("change");

            $("#profile-child-dob-text").text(params.bornBabyDOB).closest(".parent-profile-child-dob-text").show();
            $("#profile-child-dob-value").val(params.bornBabyDOB).trigger("change");
            $("#profile-child-firstname").val(params.bornBabyFName).trigger("change");
            $("#profile-child-lastname").val(params.bornBabyLName).trigger("change");
          }else{
            $("#profile-condition3-form1-due-date-text").text(params.expectedDOD);
            $("#profile-condition3-form1-dob-text").text(params.bornBabyDOB);
            $("#condition3-form1-due-date").val(params.expectedDOD).trigger("change");
            $("#condition3-form1-dob").val(params.bornBabyDOB).trigger("change");
            $("#condition3-form1-tnc").attr("checked",true).trigger("change");
            $("#condition3-form1-personal-info-collection").attr("checked",true).trigger("change");
            if(parent.optin == true){
              $("#condition3-form1-promotion").attr("checked",true).trigger("change");
            }
          }
        }
        $("#profile-condition-text").text(opt_text);
        $("#condition").val(opt_text).trigger("change");
      } else {
        //console.log(data);
        alert(data.msg);
        $("#global-loading").hide();
        location.href = "/account";
      }
    },
  }).always(function () {
    $("#global-loading").hide();
  });
}
